import React from "react";
import { useLocation } from "react-router-dom";
// reactstrap components
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import AuthNavbar from "../components/Navbars/AuthNavbar";

const AuthLayout = (props) => {
    const { headerComponent: HeaderComponent, childComponent: ChildComponent, children, ...rest } = props;
    const mainContent = React.useRef(null);
    const location = useLocation();

    React.useEffect(() => {
        document.body.classList.add("bg-default");
        return () => {
            document.body.classList.remove("bg-default");
        };
    }, []);
    React.useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainContent.current.scrollTop = 0;
    }, [location]);
    return (
        <>
            <div className="main-content" ref={mainContent}>
                <AuthNavbar />
                <div className="header bg-gradient-default py-7 py-lg-8">
                    {HeaderComponent ?
                        <Container>
                            <div className="header-body text-center mb-2">
                                <Row className="justify-content-center">
                                    <Col lg="5" md="6">
                                        <HeaderComponent {...rest}></HeaderComponent>
                                    </Col>
                                </Row>
                            </div>
                        </Container> : ""
                    }
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className="fill-default"
                                points="2560 0 2560 100 0 100"
                            />
                        </svg>
                    </div>
                </div>
                {/* Page content */}
                {(ChildComponent || children) &&
                    <Container className="mt--7 pb-5">
                        <Row className="justify-content-center">
                            <Col lg="5" md="7">
                                <Card className="bg-secondary shadow border-0">
                                    <CardBody className="px-lg-5 py-lg-5">
                                        {ChildComponent && <ChildComponent {...rest}></ChildComponent>}
                                        {children}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                }
                <footer className="py-5">
                    <Container>
                        &copy; 2021 - Yangaroo Media Flow Admin
                    </Container>
                </footer>
            </div>
        </>
    );
};

export default AuthLayout;
